// extracted by mini-css-extract-plugin
export default {"container":"DkW2-___Checkbox-module__container"};